import { BillableEntity } from '../billing-new/billableEntity';
import { DsoDetails } from './dsoDetails';

export class EParticipant {
  _id: number;
  _name: string;
  _activationRange: Date[];
  _userId: number;
  _operationId: number;
  _dsoDetails: DsoDetails;
  _billableEntity: BillableEntity;

  constructor(
    id: number,
    name: string,
    activationRange: Date[],
    userId: number,
    operationId: number,
    dsoDetails: DsoDetails,
    billableEntity: BillableEntity,
  ) {
    this._id = id;
    this._name = name;
    this._activationRange = activationRange;
    this._userId = userId;
    this._operationId = operationId;
    this._dsoDetails = dsoDetails;
    this._billableEntity = billableEntity;
  }
}
